import { FormFieldSet } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';

import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

export const PayerPickupDropoffTimeSettings = () => {
  return (
    <div className="py-4">
      <FormFieldSet
        legend="Pickup/Dropoff Times"
        columns={4}
        Fields={
          <>
            <div>
              <FormFieldController name="pickup_default_early_seconds">
                {({ field }) => {
                  return (
                    <FormField
                      label="Pickup Early (minutes)"
                      type="number"
                      inputProps={{
                        ...field,
                        id: 'pickup_default_early_seconds',
                      }}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      value={field.value}
                    />
                  );
                }}
              </FormFieldController>
            </div>
            <div>
              <FormFieldController name="pickup_default_late_seconds">
                {({ field }) => {
                  return (
                    <FormField
                      label="Pickup Late (minutes)"
                      type="number"
                      inputProps={{
                        ...field,
                        id: 'pickup_default_late_seconds',
                      }}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      value={field.value}
                    />
                  );
                }}
              </FormFieldController>
            </div>
            <div>
              <FormFieldController name="pickup_appointment_early_seconds">
                {({ field }) => {
                  return (
                    <FormField
                      label="Appointment Early (minutes)"
                      type="number"
                      inputProps={{
                        ...field,
                        id: 'pickup_appointment_early_seconds',
                      }}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      value={field.value}
                    />
                  );
                }}
              </FormFieldController>
            </div>
            <div>
              <FormFieldController name="pickup_appointment_late_seconds">
                {({ field }) => {
                  return (
                    <FormField
                      label="Appointment Late  (minutes)"
                      type="number"
                      inputProps={{
                        ...field,
                        id: 'pickup_appointment_late_seconds',
                      }}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      value={field.value}
                    />
                  );
                }}
              </FormFieldController>
            </div>
            <div>
              <FormFieldController name="pickup_will_call_early_seconds">
                {({ field }) => {
                  return (
                    <FormField
                      label="Will-call Early (minutes)"
                      type="number"
                      inputProps={{
                        ...field,
                        id: 'pickup_will_call_early_seconds',
                      }}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      value={field.value}
                    />
                  );
                }}
              </FormFieldController>
            </div>
            <div>
              <FormFieldController name="pickup_will_call_late_seconds">
                {({ field }) => {
                  return (
                    <FormField
                      label="Will-call Late (minutes)"
                      type="number"
                      inputProps={{
                        ...field,
                        id: 'pickup_will_call_late_seconds',
                      }}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      value={field.value}
                    />
                  );
                }}
              </FormFieldController>
            </div>
          </>
        }
      />
    </div>
  );
};
